import { normalize } from 'normalizr'
import { Schemas } from 'redux/schema'
import { updateEntities } from 'redux/entities'

import api from 'utils/api'
import apiV2 from 'utils/apiV2'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contenthouse/post/FETCH_REQUEST'
const FETCH_SUCCESS = 'contenthouse/post/FETCH_SUCCESS'
const FETCH_FAILURE = 'contenthouse/post/FETCH_FAILURE'

const CREATE_REQUEST = 'contenthouse/post/CREATE_REQUEST'
const CREATE_SUCCESS = 'contenthouse/post/CREATE_SUCCESS'
const CREATE_FAILURE = 'contenthouse/post/CREATE_FAILURE'

const UPDATE_REQUEST = 'contenthouse/post/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'contenthouse/post/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'contenthouse/post/UPDATE_FAILURE'

const DELETE_REQUEST = 'contenthouse/post/DELETE_REQUEST'
const DELETE_SUCCESS = 'contenthouse/post/DELETE_SUCCESS'
const DELETE_FAILURE = 'contenthouse/post/DELETE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  deleting: false,
  errors: [],
  loaded: false,
  loading: false,
  result: {},
  updating: false,
}

// Actions
export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest() {
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess() {
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []) {
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest() {
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess() {
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []) {
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest() {
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess() {
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []) {
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Action Creators
export function loadAssetPosts(postParams, options) {
  const { jobId, assetId } = postParams

  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api(`/jobs/${jobId}/assets/${assetId}/posts`, options)
      .then(({ data }) => {
        const updated = data.map((post) => ({ ...post, asset: assetId }))

        const normalizedJson = normalize(updated, Schemas.POST_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess(updated))

        return { success: true, updated }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function createPost(payload, options = {}) {
  const config = {
    method: 'POST',
    data: payload.post,
  }

  const { jobId, assetId } = payload

  return (dispatch) => {
    dispatch(createRequest())

    const promise = apiV2(`/jobs/${jobId}/assets/${assetId}/posts`, options, config)
      .then(({ data }) => {
        data.asset = assetId

        const normalizedJson = normalize(data, Schemas.POST)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        return { success: true, result: data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(createFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function deletePost(post, options = {}) {
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteRequest())

    const promise = api(`jobs/assets/posts/${post.id}`, options, config)
      .then(({ data }) => {
        const updated = data.map((x) => ({ ...x, asset: post.asset }))

        const normalizedJson = normalize(updated, Schemas.POST_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(deleteSuccess())

        return { success: true, result: updated }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(deleteFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { type, payload, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
        result: payload,
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors,
      }
    case DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
      }
    case DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        errors: [],
      }
    case DELETE_FAILURE:
      return {
        ...state,
        deleting: false,
        errors,
      }
    default:
      return state
  }
}
